/**
 * Returns true if UI application is opened in an iframe
 * Note: Browsers can block access to window.top due to same origin policy. ie bugs also take place. Hence need to try catch.
 */
export function isInIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
